
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('.section-template--30445709951324__steps_XHCTfi.results-steps-section');
    if (!root) return;

    function init(containerScope) {
      const container = containerScope && containerScope.querySelector('.steps-container');
      if (!container) return null;

      const desktop = container.classList.contains('has-carousel-desktop');
      const mobile = container.classList.contains('has-carousel-mobile');

      if (!desktop && !mobile) return null;

      const track = container.querySelector('.carousel-track');
      const slides = container.querySelectorAll('.carousel-slide');
      const navWrap = containerScope.querySelector('.steps-navigation-container');
      const prevBtn = navWrap ? navWrap.querySelector('.nav-button.prev') : null;
      const nextBtn = navWrap ? navWrap.querySelector('.nav-button.next') : null;
      if (!track || !slides.length || !prevBtn || !nextBtn) return null;

      const state = { current: 0, desktop, mobile, track, slides, prevBtn, nextBtn, container };
      function isActive() {
        const isMobile = window.innerWidth <= 768;
        return (isMobile && state.mobile) || (!isMobile && state.desktop);
      }
      function perView() {
        if (window.innerWidth <= 768 && state.mobile) return 1;
        return Math.min(4, state.slides.length);
      }
      function update() {
        if (!isActive()) return;
        const spv = perView();
        const max = Math.max(0, state.slides.length - spv);
        state.current = Math.max(0, Math.min(state.current, max));
        const slideW = 100 / spv;
        state.track.style.transform = 'translateX(' + -(state.current * slideW) + '%)';
        state.prevBtn.disabled = state.current === 0;
        state.nextBtn.disabled = state.current >= max;
        // hide nav if not needed
        if (state.prevBtn && state.nextBtn) {
          const needed = max > 0;
          state.prevBtn.parentElement.style.display = needed ? '' : 'none';
        }
      }
      function next() {
        if (!isActive()) return;
        const spv = perView();
        const max = Math.max(0, state.slides.length - spv);
        if (state.current < max) {
          state.current += window.innerWidth <= 768 && state.mobile ? 1 : spv;
          update();
        }
      }
      function prev() {
        if (!isActive()) return;
        const spv = perView();
        if (state.current > 0) {
          state.current -= window.innerWidth <= 768 && state.mobile ? 1 : spv;
          update();
        }
      }

      // Pointer / touch drag
      let down = false,
        startX = 0,
        startY = 0,
        curX = 0,
        dragging = false,
        hadVertical = false;
      function currentTransformPercent() {
        const spv = perView();
        return -(state.current * (100 / spv));
      }
      function onStart(e) {
        if (!isActive()) return;
        down = true;
        dragging = false;
        hadVertical = false;
        curX = 0;
        startX = e.touches ? e.touches[0].clientX : e.clientX;
        startY = e.touches ? e.touches[0].clientY : e.clientY;
        state.track.style.transition = 'none';
        state.track.style.cursor = 'grabbing';
      }
      function onMove(e) {
        if (!down || !isActive()) return;
        const x = e.touches ? e.touches[0].clientX : e.clientX;
        const y = e.touches ? e.touches[0].clientY : e.clientY;
        const dx = x - startX;
        const dy = y - startY;
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
          hadVertical = true;
          return;
        }
        if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
          dragging = true;
          if (e.cancelable) e.preventDefault();
          const movePct = (dx / state.track.offsetWidth) * 100;
          const t = currentTransformPercent() + movePct;
          state.track.style.transform = 'translateX(' + t + '%)';
        }
        curX = x;
      }
      function onEnd() {
        if (!down || !isActive()) return;
        down = false;
        state.track.style.cursor = 'grab';
        state.track.style.transition = 'transform .3s ease';
        if (hadVertical) {
          update();
          dragging = false;
          hadVertical = false;
          return;
        }
        if (dragging) {
          const dx = curX - startX;
          const threshold = 50;
          if (Math.abs(dx) > threshold) {
            dx > 0 ? prev() : next();
          } else {
            update();
          }
          setTimeout(() => (dragging = false), 100);
        } else {
          update();
        }
      }
      function onClick(e) {
        if (dragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }

      // Bindings
      state.nextBtn.addEventListener('click', next);
      state.prevBtn.addEventListener('click', prev);
      state.track.addEventListener('touchstart', onStart, { passive: true });
      state.track.addEventListener('touchmove', onMove, { passive: false });
      state.track.addEventListener('touchend', onEnd, { passive: true });
      if (!('ontouchstart' in window)) {
        state.track.addEventListener('mousedown', onStart);
        state.track.addEventListener('mousemove', onMove);
        state.track.addEventListener('mouseup', onEnd);
        state.track.addEventListener('mouseleave', onEnd);
      }
      state.track.addEventListener('click', onClick, true);

      // Init + resize
      update();
      window.addEventListener('resize', function () {
        state.current = 0;
        update();
      });

      return state;
    }

    const desktopScope = root.querySelector('.steps-container-desktop');
    const mobileScope = root.querySelector('.steps-container-mobile');
    const ds = desktopScope ? init(desktopScope) : null;
    const ms = mobileScope ? init(mobileScope) : null;
  });
